import PropTypes from 'prop-types';
import { useContext } from 'react';
import { renderSpinner } from '../../utils/Utility';
import { EmployeeListContext } from '../../context/EmployeeListContext';
import { UsersSelector } from '../../components/User/UsersSelector';

const minus = (minuendo, ...sottraendi) => {
  const bad = new Set(sottraendi.reduce((a, b) => a.concat(b), []));
  return minuendo.filter((item) => !bad.has(item.id));
};

export const SpeakerPartecipantSelector = ({
  participantsName,
  participants,
  setParticipants,
  speakersName,
  speakers,
  setSpeakers,
  company,
}) => {
  const { employeesQueryA, employeesByIdQueryA: employeesById, isLoadingEmployees } =
    useContext(EmployeeListContext);
  const availableUsers = employeesQueryA.filter((i) => i.company === company);
  return (
    <div>
      {renderSpinner(isLoadingEmployees)}
      <UsersSelector
        name={participantsName}
        label="Partecipanti"
        availableUsers={minus(availableUsers, speakers)}
        usersById={employeesById}
        selected={participants}
        setSelected={setParticipants}
        fixedPromptLabel={true}
      />
      <UsersSelector
        name={speakersName}
        label="Speakers / organizzatori"
        availableUsers={minus(availableUsers, participants)}
        usersById={employeesById}
        selected={speakers}
        setSelected={setSpeakers}
        fixedPromptLabel={true}
      />
    </div>
  );
};

SpeakerPartecipantSelector.propTypes = {
  participantsName: PropTypes.string.isRequired,
  participants: PropTypes.arrayOf(PropTypes.number).isRequired,
  setParticipants: PropTypes.func.isRequired,
  speakersName: PropTypes.string.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.number).isRequired,
  setSpeakers: PropTypes.func.isRequired,
  company: PropTypes.number.isRequired,
};
